import { connect } from 'react-redux'
import usersByRoleSelector from './usersByRoleSelector'
import { sagaActions as rootSagaActions } from 'store/sagas'
import UsersByRole from './UsersByRole'

export default connect(
  usersByRoleSelector,
  {
    fetchUsersByRole: rootSagaActions.fetchUsersByRole,
    requestRemoveUserRole: rootSagaActions.requestRemoveUserRole,
  }
)(UsersByRole)
